import Vue from 'vue'
import Router from 'vue-router';

Vue.use(Router)

export default new Router({
  base: __dirname,
  mode: 'history', // history 模式,nginx后端需要特殊处理
  // mode: 'hash',//hash 默认模式
  routes: [
    {
      path: '/landingPage/preview',
      name: 'preview',
      component: () => import('@/views/preview'),
      meta: {
        title: '预览',
      },
    },
    {
      path: '/landingPage/page',
      name: 'page',
      component: () => import('@/views/preview'),
      meta: {
        title: '好分期',
      },
    },
  ]
});